import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { NBSP } from 'shared/constants/symbols';

export const FirstBlock: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['textblock']}>
        <div className={styles['title']}>Новогодний адвент-календарь</div>
        <div className={styles['description']}>
          Открывайте дверцы, забирайте крутые подарки и{NBSP}получите 2026 баллов на{NBSP}продвижение на{NBSP}счет
          Циан🎄
        </div>
      </div>
      <div className={styles['video']}>
        <img className={styles['ball']} src="https://static.cdn-cian.ru/frontend/info-assets/advent/ball.gif" />
      </div>
    </div>
  );
};
